import { API, axios, SendRequest, toastr} from '@/imports-files/pages/career/customize-career-page';

export class CustomizeCareerService extends SendRequest
{
  async getCareerData(client_auth_cookies, params, hostName)
  {
    const url = API.client.career.CAREER_PAGE_PREVIEW
    try
    {
      const result = await axios({
        method: 'get',
        url: url,
        headers: {cookie: `Authorization=${client_auth_cookies}`, SLUG: hostName},
        params: params,
      });
      return result;
    }
    catch (error)
    {
      return error;
    }
  }

  async getCareerPreviewData(client_auth_cookies, params, hostName)
  {
    const url = API.client.career.CUSTOMIZE_CAREER
    params.is_preview = true
    try
    {
      const result = await axios({
        method: 'get',
        url: url,
        headers: {cookie: `Authorization=${client_auth_cookies}`, SLUG: hostName},
        params: params,
      });
      return result;
    }
    catch (error)
    {
      return error;
    }
  }

  async updateCareerPage(params) 
  {
    const url = API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
    try {
      const result = await axios.post( url,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async updateCareerPageImages(params) {
    const url = API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
    try {
      const result = await axios.post( url,
          params,
          this.setMultipartHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async publishCareerPage(params)
  {
    const url = API.client.career.PUBLISH_CAREER_PAGE;
    try {
      const result = await axios.post( url,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async resetCareerPage(params)
  {
    const url = API.client.career.RESET_CAREER_PAGE;
    try {
      const result = await axios.post( url,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      console.log(error)
      return error;
    }
  }
}
